/**
 * @file コンポーネント：フル動画ページコントローラー ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const ContentsController = (props) => {
    /**
     * 表示タブ
     */
    const [selectedTabController, setSelectedTabController] =
        useState("timeline");
    useEffect(() => {
        if (selectedTabController === "playersetting") {
            props.setSelectedContentsData("fullvideo");
        }
    }, [selectedTabController]);

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            selectedTabController={selectedTabController}
            setSelectedTabController={setSelectedTabController}
        />
    );
};
